import SearchIcon from '@mui/icons-material/Search';
import {
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  styled,
  TextField,
} from '@mui/material';
import {get} from 'lodash';
import {FC} from 'react';
import {
  CONTRACT_TABLE_SEARCH_CATEGORIES,
  CONTRACT_TABLE_SEARCH_PLACEHOLDERS,
} from '../../constants/contract-table-search-categories.constants';
import {useContractsTableData} from '../../hooks/use-contracts-table-data.hook';
import {setSearchCategory, setSearchQuery, useContractsTableSearchStore} from '../../stores/contracts-search.store';
import {setContractTablePage} from '../../stores/contracts-table.store';

type SelectValue = (typeof CONTRACT_TABLE_SEARCH_CATEGORIES)[number]['value'];

export const ContractsTableSearch: FC = () => {
  const {searchCategory, searchQuery} = useContractsTableSearchStore();
  const {loading} = useContractsTableData();

  const placeholder = get(CONTRACT_TABLE_SEARCH_PLACEHOLDERS, searchCategory);

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = get(event, 'target.value');
    setSearchQuery(event.target.value);
    if (value) setContractTablePage(null, 0);
  };

  const handleSearchCategoryChange = (event: SelectChangeEvent<SelectValue>) => {
    const value = get(event, 'target.value');
    setSearchCategory(value as SelectValue);
    setSearchQuery('');
  };

  return (
    <Stack>
      <Stack direction="row" alignItems="center" gap={4}>
        <StyledTextField
          value={searchQuery}
          onChange={handleSearchChange}
          InputProps={{endAdornment: renderEndAdornment(loading)}}
          placeholder={placeholder}
        />

        <StyledFormControl variant="standard">
          <InputLabel id="searchBy">Критерий поиска</InputLabel>
          <Select labelId="searchBy" onChange={handleSearchCategoryChange} value={searchCategory}>
            {CONTRACT_TABLE_SEARCH_CATEGORIES.map((category) => (
              <MenuItem key={category.value} value={category.value}>
                {category.label}
              </MenuItem>
            ))}
          </Select>
        </StyledFormControl>
      </Stack>
    </Stack>
  );
};

function renderEndAdornment(isLoading?: boolean) {
  return <Stack width={24} children={isLoading ? <CircularProgress size={18} /> : <SearchIcon color="disabled" />} />;
}

const StyledFormControl = styled(FormControl)({
  minWidth: '168px',
  marginTop: -8,
});

const StyledTextField = styled(TextField)({
  minWidth: '364px',

  '& .MuiTextField-root': {
    border: '0.5px solid #B9B9B9',
    borderRadius: '4px',
  },
  '& .MuiInputBase-input': {
    padding: '8.5px 14px',
  },
});
